export const MAXIMUM_TICKET_AMOUNT = 100_000_000;
